import { render, staticRenderFns } from "./SourceTrainingSimilarityTable.vue?vue&type=template&id=7568501c&scoped=true&"
import script from "./SourceTrainingSimilarityTable.vue?vue&type=script&lang=js&"
export * from "./SourceTrainingSimilarityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568501c",
  null
  
)

export default component.exports